import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.register');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-register',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.register/view.scss */
:host {
  display: block;
  min-height: 100vh;
  background: #e9e6de;
  color: #13202d;
}

.auth-page,
.auth-page * {
  box-sizing: border-box;
}

button,
input {
  font: inherit;
}

button,
a {
  -webkit-tap-highlight-color: transparent;
}

.auth-page {
  --ink: #0b1724;
  --ink-soft: #17283a;
  --paper: #fbfaf6;
  --line: #ddd9cf;
  --muted: #6c7883;
  --accent: #b66b32;
  --gold: #c8a366;
  position: relative;
  display: grid;
  min-height: 100vh;
  place-items: center;
  overflow: hidden;
  padding: clamp(20px, 2.5vw, 40px);
  background: radial-gradient(circle at 14% 10%, rgba(255, 255, 255, 0.9), transparent 31%), radial-gradient(circle at 88% 92%, rgba(160, 117, 69, 0.12), transparent 28%), #e9e6de;
}

.auth-page::before {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(25, 40, 52, 0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(25, 40, 52, 0.035) 1px, transparent 1px);
  background-size: 48px 48px;
  content: "";
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.72), transparent 78%);
  pointer-events: none;
}

.auth-page__glow {
  position: absolute;
  width: 420px;
  height: 420px;
  border-radius: 999px;
  filter: blur(10px);
  pointer-events: none;
}

.auth-page__glow--one {
  top: -240px;
  right: 15%;
  background: rgba(189, 151, 93, 0.12);
}

.auth-page__glow--two {
  bottom: -300px;
  left: 30%;
  background: rgba(39, 72, 88, 0.11);
}

.auth-frame {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(520px, 1.16fr) minmax(550px, 0.84fr);
  width: min(1720px, 100vw - clamp(40px, 6vw, 128px));
  min-height: min(880px, 100vh - 80px);
  overflow: hidden;
  border: 1px solid rgba(17, 31, 44, 0.1);
  border-radius: 30px;
  background: var(--paper);
  box-shadow: 0 40px 100px rgba(30, 37, 43, 0.16), 0 4px 16px rgba(30, 37, 43, 0.08);
  view-transition-name: auth-frame;
}

.auth-frame--register {
  min-height: min(920px, 100vh - 80px);
}

.archive-panel {
  position: relative;
  isolation: isolate;
  display: flex;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  padding: clamp(36px, 4vw, 72px);
  color: #fff;
  background: radial-gradient(circle at 78% 18%, rgba(195, 153, 92, 0.18), transparent 30%), linear-gradient(145deg, #102638 0%, #081725 56%, #07131f 100%);
}

.archive-panel::after {
  position: absolute;
  right: -90px;
  bottom: -120px;
  width: 470px;
  height: 470px;
  border: 1px solid rgba(210, 180, 131, 0.12);
  border-radius: 50%;
  box-shadow: 0 0 0 54px rgba(210, 180, 131, 0.035), 0 0 0 108px rgba(210, 180, 131, 0.025);
  content: "";
  pointer-events: none;
}

.archive-panel__texture {
  position: absolute;
  z-index: -1;
  inset: 0;
  background: linear-gradient(180deg, rgba(8, 22, 34, 0.2), rgba(8, 22, 34, 0.78)), url("/assets/nahf/covers/cj.jpg") center 24%/cover no-repeat;
  opacity: 0.16;
  filter: grayscale(1) contrast(1.15);
  transform: scale(1.06);
}

.archive-brand {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 14px;
}

.archive-brand__mark {
  display: grid;
  width: 46px;
  height: 46px;
  place-items: center;
  border: 1px solid rgba(223, 194, 146, 0.55);
  color: #e0bd81;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 23px;
  line-height: 1;
}

.archive-brand div {
  display: grid;
  gap: 4px;
}

.archive-brand strong {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.archive-brand span {
  color: rgba(255, 255, 255, 0.55);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.22em;
}

.archive-copy {
  position: relative;
  z-index: 2;
  width: min(620px, 92%);
  margin: auto 0;
  padding: 48px 0 38px;
}

.archive-eyebrow {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #d7b77f;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.2em;
}

.archive-eyebrow i {
  width: 26px;
  height: 1px;
  background: currentColor;
}

.archive-copy h1 {
  margin: 24px 0 22px;
  color: #fff;
  font-size: clamp(40px, 3.25vw, 62px);
  font-weight: 650;
  letter-spacing: -0.045em;
  line-height: 1.16;
}

.archive-copy h1 em {
  color: #d2ae70;
  font-family: Georgia, "Times New Roman", serif;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.035em;
}

.archive-copy > p {
  max-width: 530px;
  margin: 0;
  color: rgba(238, 244, 247, 0.7);
  font-size: 14px;
  line-height: 1.85;
  word-break: keep-all;
}

.archive-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px;
  margin-top: 38px;
  padding-top: 28px;
  border-top: 1px solid rgba(255, 255, 255, 0.13);
}

.archive-meta > div {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.archive-meta > div > span {
  display: grid;
  width: 29px;
  height: 29px;
  flex: 0 0 29px;
  place-items: center;
  border: 1px solid rgba(213, 178, 117, 0.35);
  border-radius: 50%;
  color: #d7b77f;
  font-family: Georgia, serif;
  font-size: 10px;
}

.archive-meta p {
  display: grid;
  gap: 4px;
  margin: 0;
}

.archive-meta strong {
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  font-weight: 650;
}

.archive-meta small {
  color: rgba(255, 255, 255, 0.43);
  font-size: 10px;
  line-height: 1.5;
}

.archive-showcase {
  position: relative;
  z-index: 2;
}

.showcase-heading {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.19em;
}

.showcase-heading i {
  height: 1px;
  flex: 1;
  background: rgba(255, 255, 255, 0.12);
}

.cover-stack {
  display: flex;
  align-items: flex-end;
  height: 132px;
  padding-left: 6px;
}

.cover-card {
  position: relative;
  width: 88px;
  height: 122px;
  overflow: hidden;
  margin: 0;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 4px;
  background: #d8d0c0;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
  transform-origin: bottom center;
  transition: transform 250ms ease, filter 250ms ease;
}

.cover-card + .cover-card {
  margin-left: -17px;
}

.cover-card--one {
  z-index: 1;
  transform: rotate(-7deg) translateY(6px);
}

.cover-card--two {
  z-index: 3;
  transform: translateY(-2px);
}

.cover-card--three {
  z-index: 2;
  transform: rotate(7deg) translateY(7px);
}

.cover-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-stack:hover .cover-card--one {
  transform: rotate(-9deg) translate(-5px, 2px);
}

.cover-stack:hover .cover-card--two {
  transform: translateY(-9px);
}

.cover-stack:hover .cover-card--three {
  transform: rotate(9deg) translate(5px, 3px);
}

.archive-caption {
  margin: 8px 0 0;
  color: rgba(255, 255, 255, 0.38);
  font-size: 10px;
}

.auth-panel {
  position: relative;
  display: grid;
  min-width: 0;
  place-items: center;
  padding: clamp(34px, 4vw, 68px);
  background: linear-gradient(rgba(251, 250, 246, 0.94), rgba(251, 250, 246, 0.94)), repeating-linear-gradient(0deg, transparent 0 27px, rgba(18, 34, 47, 0.025) 27px 28px);
  view-transition-name: auth-panel;
}

.auth-panel::before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 1px;
  background: linear-gradient(to bottom, transparent, rgba(15, 30, 43, 0.13) 12%, rgba(15, 30, 43, 0.13) 88%, transparent);
  content: "";
}

.auth-panel__inner {
  width: min(100%, 520px);
}

.form-brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.form-brand img {
  width: auto;
  height: 41px;
  object-fit: contain;
}

.form-brand span {
  color: #8b7e69;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.15em;
  white-space: nowrap;
}

.auth-switch {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 28px;
  padding: 5px;
  border: 1px solid #dedad0;
  border-radius: 14px;
  background: #efede6;
}

.auth-switch__item {
  position: relative;
  display: grid;
  height: 44px;
  place-items: center;
  border-radius: 10px;
  color: #7c8389;
  font-size: 13px;
  font-weight: 650;
  text-decoration: none;
  transition: color 180ms ease, background 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.auth-switch__item:hover {
  color: var(--ink);
}

.auth-switch__item:active {
  transform: scale(0.985);
}

.auth-switch__item.is-active {
  color: var(--ink);
  background: #fff;
  box-shadow: 0 4px 15px rgba(29, 38, 44, 0.09), inset 0 0 0 1px rgba(255, 255, 255, 0.7);
}

.auth-switch__item.is-active::after {
  position: absolute;
  right: 26%;
  bottom: 7px;
  left: 26%;
  height: 2px;
  border-radius: 2px;
  background: var(--accent);
  content: "";
}

.form-intro {
  margin: 42px 0 30px;
}

.form-intro--compact {
  margin-top: 30px;
  margin-bottom: 20px;
}

.form-intro > span {
  color: var(--accent);
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.18em;
}

.form-intro h2 {
  margin: 10px 0 8px;
  color: var(--ink);
  font-size: clamp(28px, 2vw, 35px);
  font-weight: 700;
  letter-spacing: -0.035em;
  line-height: 1.25;
}

.form-intro p {
  margin: 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.7;
  word-break: keep-all;
}

.status-message {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: -10px 0 20px;
  padding: 11px 13px;
  border: 1px solid;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
}

.status-message svg {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  margin-top: 1px;
}

.status-message--error {
  border-color: #edc6c0;
  color: #a23f34;
  background: #fff2ef;
}

.status-message--success {
  border-color: #b8ddca;
  color: #287550;
  background: #effbf5;
}

.auth-form {
  display: grid;
  gap: 20px;
}

.auth-form--register {
  gap: 14px;
}

.field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px;
}

.field-group {
  display: grid;
  gap: 8px;
}

.field-group label,
.field-label-row label {
  color: #2e3c48;
  font-size: 11px;
  font-weight: 750;
}

.field-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.field-label-row span {
  color: #92999e;
  font-size: 9px;
  font-weight: 600;
}

.field-control {
  position: relative;
  display: flex;
  height: 54px;
  align-items: center;
  overflow: hidden;
  border: 1px solid #d7d4ca;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
  transition: border-color 180ms ease, box-shadow 180ms ease, background 180ms ease;
}

.auth-form--register .field-control {
  height: 49px;
}

.field-control:focus-within {
  border-color: #7c8c92;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(42, 74, 85, 0.09);
}

.field-control.has-error {
  border-color: #ce7569;
  box-shadow: 0 0 0 3px rgba(192, 82, 68, 0.08);
}

.field-control > svg {
  position: absolute;
  left: 16px;
  width: 18px;
  height: 18px;
  color: #8c969b;
  pointer-events: none;
}

.field-control input {
  width: 100%;
  height: 100%;
  border: 0;
  outline: 0;
  padding: 0 16px;
  color: #142430;
  background: transparent;
  font-size: 13px;
  font-weight: 550;
}

.field-control > svg + input {
  padding-left: 47px;
}

.field-control--password input {
  padding-right: 50px;
}

.field-control input::placeholder {
  color: #a6aaac;
  font-weight: 450;
}

.visibility-button {
  position: absolute;
  right: 8px;
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  color: #758188;
  background: transparent;
  cursor: pointer;
  transition: color 160ms ease, background 160ms ease;
}

.visibility-button:hover {
  color: var(--ink);
  background: #eeece5;
}

.visibility-button svg {
  width: 18px;
  height: 18px;
}

.field-error {
  margin: -1px 0 0;
  color: #b44c40;
  font-size: 10px;
  font-weight: 650;
}

.primary-action {
  display: flex;
  width: 100%;
  height: 56px;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
  border: 0;
  border-radius: 11px;
  padding: 0 20px 0 22px;
  color: #fff;
  background: linear-gradient(115deg, #0c1a28, #183247);
  box-shadow: 0 13px 25px rgba(13, 31, 45, 0.18);
  cursor: pointer;
  font-size: 13px;
  font-weight: 750;
  transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;
}

.auth-form--register .primary-action {
  height: 51px;
}

.primary-action:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 17px 31px rgba(13, 31, 45, 0.22);
  filter: brightness(1.08);
}

.primary-action:active:not(:disabled) {
  transform: translateY(0);
}

.primary-action:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.primary-action svg {
  width: 19px;
  height: 19px;
}

.auth-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 30px;
  padding-top: 21px;
  border-top: 1px solid #e3e0d7;
  color: #7b858c;
  font-size: 10px;
}

.auth-footer > div {
  display: flex;
  align-items: center;
  gap: 7px;
}

.auth-footer i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #5f956c;
  box-shadow: 0 0 0 4px rgba(95, 149, 108, 0.1);
}

.auth-footer p {
  margin: 0;
}

.auth-footer a {
  margin-left: 7px;
  color: var(--ink);
  font-weight: 800;
  text-decoration: none;
}

.auth-footer a:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
}

@keyframes frame-enter {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.992);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes form-enter {
  from {
    opacity: 0;
    transform: translateX(16px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@view-transition {
  navigation: auto;
}
::view-transition-group(auth-frame),
::view-transition-group(auth-panel) {
  animation-duration: 480ms;
  animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
}

::view-transition-old(auth-panel) {
  animation: panel-old 260ms ease-in both;
}

::view-transition-new(auth-panel) {
  animation: panel-new 460ms 50ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes panel-old {
  to {
    opacity: 0;
    transform: translateX(-12px);
  }
}
@keyframes panel-new {
  from {
    opacity: 0;
    transform: translateX(16px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (max-width: 1120px) {
  .auth-page {
    padding: 22px;
  }
  .auth-frame {
    grid-template-columns: minmax(420px, 1fr) minmax(500px, 1fr);
    width: 100%;
  }
  .archive-panel {
    padding: 38px;
  }
  .archive-copy {
    width: 100%;
  }
  .archive-meta {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .archive-meta small {
    display: none;
  }
  .auth-panel {
    padding: 38px;
  }
}
@media (max-width: 920px) {
  .auth-page {
    display: block;
    overflow: visible;
    padding: 0;
  }
  .auth-frame,
  .auth-frame--register {
    display: block;
    width: 100%;
    min-height: 100vh;
    border: 0;
    border-radius: 0;
  }
  .archive-panel {
    min-height: 300px;
    padding: 30px;
  }
  .archive-copy {
    margin: 48px 0 0;
    padding: 0;
  }
  .archive-copy h1 {
    margin: 16px 0 13px;
    font-size: 36px;
  }
  .archive-copy > p {
    max-width: 580px;
  }
  .archive-meta,
  .archive-showcase {
    display: none;
  }
  .auth-panel {
    min-height: calc(100vh - 300px);
    padding: 42px 28px 48px;
  }
  .auth-panel::before {
    display: none;
  }
}
@media (max-width: 560px) {
  .archive-panel {
    min-height: 240px;
    padding: 24px 20px;
  }
  .archive-brand__mark {
    width: 39px;
    height: 39px;
    font-size: 19px;
  }
  .archive-brand strong {
    font-size: 13px;
  }
  .archive-brand span {
    font-size: 8px;
  }
  .archive-copy {
    margin-top: 37px;
  }
  .archive-eyebrow {
    font-size: 8px;
  }
  .archive-copy h1 {
    margin-top: 13px;
    font-size: 30px;
  }
  .archive-copy > p {
    display: none;
  }
  .auth-panel {
    min-height: calc(100vh - 240px);
    padding: 32px 20px 40px;
  }
  .form-brand span {
    display: none;
  }
  .form-brand img {
    height: 37px;
  }
  .auth-switch {
    margin-top: 22px;
  }
  .form-intro,
  .form-intro--compact {
    margin: 28px 0 22px;
  }
  .form-intro h2 {
    font-size: 27px;
  }
  .field-grid {
    grid-template-columns: 1fr;
  }
  .auth-footer {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (prefers-reduced-motion: reduce) {
  .auth-frame,
  .auth-panel__inner {
    animation: none;
  }
  .auth-switch__item,
  .field-control,
  .primary-action,
  .cover-card {
    transition: none;
  }
}`],
})
export class PageRegisterComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = false;
    public passwordVisible: boolean = false;
    public confirmVisible: boolean = false;
    public errorMessage: string = '';
    public successMessage: string = '';
    public data: any = {
        id: '',
        name: '',
        email: '',
        password: '',
        password_confirm: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.replace('/home');
        await this.service.render();
    }

    public async togglePassword() {
        this.passwordVisible = !this.passwordVisible;
        await this.service.render();
    }

    public async toggleConfirmPassword() {
        this.confirmVisible = !this.confirmVisible;
        await this.service.render();
    }

    private async showError(message: string) {
        this.errorMessage = message;
        this.successMessage = '';
        await this.service.render();
    }

    public passwordsMatch() {
        if (!this.data.password_confirm) return true;
        return this.data.password === this.data.password_confirm;
    }

    public async register() {
        if (this.loading) return;

        let payload = JSON.parse(JSON.stringify(this.data));
        payload.id = (payload.id || '').trim();
        payload.name = (payload.name || '').trim();
        payload.email = (payload.email || '').trim();
        this.errorMessage = '';
        this.successMessage = '';

        if (!payload.id) {
            await this.showError('아이디를 입력해주세요.');
            return;
        }
        if (!payload.password) {
            await this.showError('비밀번호를 입력해주세요.');
            return;
        }
        if (payload.password !== payload.password_confirm) {
            await this.showError('비밀번호 확인이 일치하지 않습니다.');
            return;
        }

        this.loading = true;
        await this.service.render();

        let { code, data } = await wiz.call('register', payload);
        this.loading = false;

        if (code == 200) {
            this.successMessage = '회원가입이 완료되었습니다. 로그인 화면으로 이동합니다.';
            await this.service.render();
            setTimeout(() => location.replace('/login'), 700);
            return;
        }

        await this.showError((data && data.message) || '회원가입에 실패했습니다.');
    }
}

export default PageRegisterComponent;